import React, { useState } from 'react';
import { kbCurationAPI } from '../../services/api';

export default function ProposalApproveModal({ proposal, onClose, onDone }) {
  const [texto, setTexto] = useState(proposal.texto_original);
  const [tipoUso, setTipoUso] = useState('ambos');
  const [busy, setBusy] = useState(false);
  const esQA = proposal.tipo === 'qa_pair';
  const tieneMatch = !!proposal.match_common_question_id;
  const [qaMatchAccion, setQaMatchAccion] = useState('merge_cq');
  const [crearPlantilla, setCrearPlantilla] = useState(true);
  const [crearCq, setCrearCq] = useState(false);

  function buildBody() {
    let accion = 'plantilla';
    if (esQA && tieneMatch) accion = qaMatchAccion;
    else if (esQA && !tieneMatch) {
      if (crearPlantilla && crearCq) accion = 'plantilla+new_cq';
      else if (crearCq) accion = 'new_cq';
      else accion = 'plantilla';
    }
    return { texto, categoria: proposal.categoria, tipo_uso: tipoUso, accion, merge_target: proposal.match_common_question_id };
  }
  async function submit() {
    setBusy(true);
    try { await kbCurationAPI.approve(proposal.id, buildBody()); onDone(); }
    catch (e) { alert('Error al aprobar: ' + (e?.message || e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-5 w-[600px] max-h-[80vh] overflow-auto">
        <h2 className="font-bold mb-2">Aprobar propuesta #{proposal.id}</h2>
        {esQA && proposal.pregunta_cliente && (
          <p className="text-sm text-gray-500 mb-1">Pregunta: {proposal.pregunta_norm || proposal.pregunta_cliente}</p>
        )}
        <textarea value={texto} onChange={e=>setTexto(e.target.value)} className="w-full border rounded p-2 text-sm h-40" />
        {!esQA && (
          <div className="mt-2 text-sm">tipo_uso:
            <select value={tipoUso} onChange={e=>setTipoUso(e.target.value)} className="ml-2 border rounded">
              <option value="ambos">ambos</option><option value="verbatim">verbatim</option><option value="elaboracion">elaboracion</option>
            </select></div>
        )}
        {esQA && tieneMatch && (
          <div className="mt-2 text-sm space-y-1">
            <label className="block"><input type="radio" checked={qaMatchAccion==='merge_cq'} onChange={()=>setQaMatchAccion('merge_cq')} /> Actualizar pregunta existente #{proposal.match_common_question_id}</label>
            <label className="block"><input type="radio" checked={qaMatchAccion==='plantilla'} onChange={()=>setQaMatchAccion('plantilla')} /> Crear plantilla nueva en kb_qa</label>
          </div>
        )}
        {esQA && !tieneMatch && (
          <div className="mt-2 text-sm space-y-1">
            <label className="block"><input type="checkbox" checked={crearPlantilla} onChange={e=>setCrearPlantilla(e.target.checked)} /> Crear plantilla en kb_qa</label>
            <label className="block"><input type="checkbox" checked={crearCq} onChange={e=>setCrearCq(e.target.checked)} /> Crear nueva pregunta en ventas_common_questions</label>
          </div>
        )}
        <div className="mt-4 flex gap-2 justify-end">
          <button onClick={onClose} disabled={busy} className="px-3 py-1.5 bg-gray-200 rounded">Cancelar</button>
          <button onClick={submit} disabled={busy} className="px-3 py-1.5 bg-green-600 text-white rounded">{busy?'...':'Aprobar'}</button>
        </div>
      </div>
    </div>
  );
}
